import { Link } from "react-router-dom";
import { ArrowRight, Phone, HelpCircle, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IMAGES } from "@/assets/images";
const Gateway = () => {
  return <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-emerald-50">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-100 to-emerald-100"></div>
      </div>

      <div className="relative z-10">
        {/* Header */}
        <div className="text-center pt-8 pb-6 px-4 bg-[rgb(255,255,255)]">
          <div className="mb-6">
            <img src="/images/logo hirondelles fond transparent.jpg" alt="Les Hirondelles" className="h-16 lg:h-20 mx-auto" />
          </div>
          
          <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">
            Les Hirondelles
          </h1>
          <p className="text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Solutions de mobilité vélo sur la côte atlantique
          </p>
        </div>

        {/* Main Content */}
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
          <div className="grid lg:grid-cols-2 gap-6 lg:gap-8">
            
            {/* BLOCK 1 - PARTICULIERS */}
            <Link to="/particuliers" className="group block bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden border border-blue-100">
              {/* Image */}
              <div className="relative h-56 lg:h-64 overflow-hidden">
                <img src={IMAGES.CAMPING_VELO_3} alt="Services particuliers - Location vélos campings" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/60 via-blue-900/20 to-transparent"></div>
                
                {/* Badge */}
                <div className="absolute top-4 right-4 bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium shadow-lg">
                  Particuliers
                </div>
                
                {/* Arrow Icon */}
                <div className="absolute bottom-4 right-4 bg-white/20 backdrop-blur-sm text-white p-3 rounded-full group-hover:bg-blue-500 group-hover:scale-110 transition-all shadow-lg">
                  <ArrowRight className="w-5 h-5" />
                </div>
              </div>

              {/* Content */}
              <div className="p-6 lg:p-8">
                <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                  Pour les particuliers
                </h2>
                
                <p className="text-gray-600 text-base lg:text-lg mb-6 leading-relaxed">
                  Réserver un vélo, se faire livrer, acheter un vélo reconditionné ou trouver le modèle adapté à vos besoins.
                </p>

                {/* Services Preview */}
                <div className="space-y-2 mb-6">
                  <div className="flex items-center text-gray-700">
                    <CheckCircle className="w-4 h-4 text-blue-500 mr-3 flex-shrink-0" />
                    <span className="text-sm">Location dans les campings</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <CheckCircle className="w-4 h-4 text-blue-500 mr-3 flex-shrink-0" />
                    <span className="text-sm">Livraison de vélos</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <CheckCircle className="w-4 h-4 text-blue-500 mr-3 flex-shrink-0" />
                    <span className="text-sm">Vélos reconditionnés</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <CheckCircle className="w-4 h-4 text-blue-500 mr-3 flex-shrink-0" />
                    <span className="text-sm">Recherche personnalisée</span>
                  </div>
                </div>

                {/* CTA Button */}
                <Button className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 text-base rounded-xl group-hover:bg-blue-600 transition-all shadow-md hover:shadow-lg">
                  Accéder à l'espace particuliers
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </div>
            </Link>

            {/* BLOCK 2 - PROFESSIONNELS */}
            <Link to="/professionnels" className="group block bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden border border-emerald-100">
              {/* Image */}
              <div className="relative h-56 lg:h-64 overflow-hidden">
                <img src={IMAGES.CORPORATE_GROUP_CYCLING_20260211_111333_15} alt="Solutions professionnelles - Parcs vélos entreprises" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/60 via-emerald-900/20 to-transparent"></div>
                
                {/* Badge */}
                <div className="absolute top-4 right-4 bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-medium shadow-lg">
                  Professionnels
                </div>
                
                {/* Arrow Icon */}
                <div className="absolute bottom-4 right-4 bg-white/20 backdrop-blur-sm text-white p-3 rounded-full group-hover:bg-emerald-600 group-hover:scale-110 transition-all shadow-lg">
                  <ArrowRight className="w-5 h-5" />
                </div>
              </div>

              {/* Content */}
              <div className="p-6 lg:p-8">
                <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors">
                  Pour les professionnels
                </h2>
                
                <p className="text-gray-600 text-base lg:text-lg mb-6 leading-relaxed">
                  Mettre en place une offre vélo performante pour votre établissement, avec des solutions adaptées à votre activité.
                </p>

                {/* Services Preview */}
                <div className="space-y-2 mb-6">
                  <div className="flex items-center text-gray-700">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-3 flex-shrink-0" />
                    <span className="text-sm">Location longue durée</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-3 flex-shrink-0" />
                    <span className="text-sm">Offre clé en main</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-3 flex-shrink-0" />
                    <span className="text-sm">Mise à disposition de parc</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-3 flex-shrink-0" />
                    <span className="text-sm">Bornes auto-réparation</span>
                  </div>
                </div>

                {/* CTA Button */}
                <Button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 text-base rounded-xl group-hover:bg-emerald-700 transition-all shadow-md hover:shadow-lg">
                  Accéder à l'espace professionnels
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </div>
            </Link>
          </div>
        </div>

        {/* Footer Gateway */}
        <div className="bg-white/80 backdrop-blur-sm border-t border-gray-200 py-6">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
              
              {/* Contact Info */}
              <div className="flex items-center space-x-6">
                <div className="flex items-center text-gray-600">
                  <Phone className="w-4 h-4 mr-2 text-emerald-600" />
                  <span className="font-medium text-sm">Besoin d'aide ?</span>
                </div>
                <Link to="/nous-contacter" className="text-emerald-600 hover:text-emerald-700 font-medium transition-colors text-sm">
                  Nous contacter
                </Link>
              </div>

              {/* FAQ Access */}
              <div className="flex items-center">
                <Link to="/faq" className="flex items-center text-gray-600 hover:text-emerald-600 transition-colors text-sm">
                  <HelpCircle className="w-4 h-4 mr-2" />
                  <span>Questions fréquentes</span>
                </Link>
              </div>
            </div>

            {/* Reassurance Line */}
            <div className="text-center mt-4 pt-4 border-t border-gray-200">
              <p className="text-gray-500 text-xs">
                ✓ Service vélo de confiance sur la côte atlantique depuis 2018
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Gateway;